// extracted by mini-css-extract-plugin
module.exports = {"modal":"SubCardGroup_modal__3N9t-","cardContainer":"SubCardGroup_cardContainer__3khq5","body":"SubCardGroup_body__2s8tr","progressBody":"SubCardGroup_progressBody__2aU7q"};